import { cn } from '@neo/lib/utils'
import { Badge } from '@neo/primitives/badge'
import { AlertTriangle, Check, X } from 'lucide-react'
import { EvalStatus } from './types'

interface EvalBadgeProps {
  evalStatus: EvalStatus | null | undefined
  evalPassedCount?: number
  evalTotalCount?: number
  id: string
}

export const EvalBadge = ({ evalStatus, evalPassedCount, evalTotalCount, id }: EvalBadgeProps) => {
  if (!evalStatus) return null

  let badgeProps: { icon?: React.ReactNode; className?: string } | null = null

  if (evalStatus === EvalStatus.Passed) {
    badgeProps = {
      icon: <Check className="text-status-success" aria-hidden />,
      className: 'bg-success-tag rounded-md ',
    }
  }

  if (evalStatus === EvalStatus.Failed) {
    badgeProps = {
      icon: <X className=" text-status-danger" aria-hidden />,
      className: 'bg-danger rounded-md ',
    }
  }

  if (
    evalStatus === EvalStatus.Partial &&
    evalPassedCount !== undefined &&
    evalTotalCount !== undefined
  ) {
    badgeProps = {
      icon: <AlertTriangle className="text-status-warning" aria-hidden />,
      className: 'bg-warning rounded-md ',
    }
  }

  if (!badgeProps) return null

  return (
    <Badge
      className={cn(
        'absolute bottom-2 right-2 size-6 p-1 z-20 pointer-events-none',
        badgeProps.className,
      )}
      data-testid={`eval-badge-${id}`}
    >
      {badgeProps.icon}
    </Badge>
  )
}
